var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cartError
    ? _c("div", { staticClass: "fs-3 mt-5 container-medium m-auto" }, [
        _c("header", { staticClass: "mb-5 px-5 py-0" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
            _c("h2", { staticClass: "m-0 mb-2 dinlineb" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Abonnement Sellsy")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-small m-auto cart-error-container" },
          [
            _vm.isCartLoaded && _vm.savedCartStatus == "canceled"
              ? _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$l10n.__("Ce panier a été annulé")) +
                      "\n        "
                  )
                ])
              : _vm.isCartLoaded && _vm.savedCartStatus == "paid"
              ? _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$l10n.__("Ce panier a été validé et payé")) +
                      "\n        "
                  )
                ])
              : !_vm.userIsSellsy && _vm.isCartLoaded && !_vm.canEditCart
              ? _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Un panier validé est en attente de paiement, veuillez le régler avant de pouvoir éditer un nouveau panier ou contacter notre service commercial"
                        )
                      ) +
                      "\n        "
                  )
                ])
              : !_vm.userIsSellsy &&
                _vm.hasScheduledSubscription &&
                !_vm.canEditCart
              ? _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "L'activation de votre abonnement est programmée ou en cours de finalisation"
                        )
                      ) +
                      "\n        "
                  )
                ])
              : _vm.userIsSellsy &&
                _vm.hasScheduledSubscription &&
                !_vm.canEditCart
              ? _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Le client a validé son abonnement, mais celui-ci est programmé ou en cours de finalisation"
                        )
                      ) +
                      "\n        "
                  )
                ])
              : _vm.userIsSellsy &&
                _vm.isCartLoaded &&
                !_vm.canEditCart &&
                _vm.savedCartStatus == "validating"
              ? _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Le client a validé son panier, mais pas son moyen de paiement, il est nécessaire qu'il soit validé pour les modifications apportées par le panier soient prises en compte sur son abonnement"
                        )
                      ) +
                      "\n        "
                  )
                ])
              : _vm.userIsSellsy && _vm.isCartLoaded && !_vm.canEditCart
              ? _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Le client a un panier validé en attente de paiement, il est nécessaire qu'il soit payé avant de pouvoir éditer un nouveau panier ou il faut annuler"
                        )
                      ) +
                      "\n        "
                  )
                ])
              : _c("p", { staticClass: "cart-error-txt" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "La modification d’abonnement client sera très vite disponible."
                        )
                      ) +
                      "\n        "
                  )
                ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "cart-error-btn acenter" },
              [
                !_vm.userIsSellsy
                  ? _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.contact_sales")
                      },
                      on: { click: _vm.contactCommercialUrl }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.userIsSellsy
                  ? _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__(
                          "sellsyaccountmanager.SubscriptionForm.back_to_sellsy"
                        )
                      },
                      on: { click: _vm.homeUrl }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ])
    : _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "fs-3 mt-5 container-medium m-auto"
        },
        [
          _c("loader-full-page", { attrs: { display: _vm.loadingInit } }),
          _vm._v(" "),
          _c("header", { staticClass: "mb-5 px-5 py-0" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
              _c("h2", { staticClass: "m-0 mb-2 dinlineb" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Abonnement Sellsy")))
              ]),
              _vm._v(" "),
              !_vm.userIsSellsy
                ? _c(
                    "div",
                    { staticClass: "dinlineb ml-3" },
                    _vm._l(_vm.stepsList, function(breadcrumb, index) {
                      return _c(
                        "span",
                        {
                          key: breadcrumb.id,
                          class:
                            breadcrumb === _vm.activeStep ? "primary-50" : ""
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                index
                                  ? " / " + breadcrumb.label
                                  : breadcrumb.label
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.userIsSellsy && _vm.activeStep.id !== "finalize"
                ? _c(
                    "span",
                    [
                      _vm.stepHasPreviousOne
                        ? _c("CompassBackForwardButton", {
                            staticClass: "subscriptionform-back",
                            attrs: {
                              label: _vm.$t.__("common.actions.back"),
                              link: "javascript:;",
                              back: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.previousStep()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.stepHasPreviousOne
                        ? _c("CompassBackForwardButton", {
                            staticClass: "subscriptionform-back",
                            attrs: {
                              label: _vm.$t.__("common.actions.back"),
                              link: "javascript:history.back();",
                              back: ""
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm.userIsSellsy
                ? _c(
                    "span",
                    [
                      _c("CompassBackForwardButton", {
                        staticClass: "subscriptionform-back",
                        attrs: {
                          label: _vm.$t.__("common.actions.back"),
                          link: _vm.urlToCustomerThirdOverview,
                          back: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          !_vm.userIsSellsy && !_vm.loadingInit
            ? _c(
                "div",
                { staticClass: "container-small m-auto" },
                [
                  _c(
                    "keep-alive",
                    [
                      _vm.step("subscription") == _vm.activeStep
                        ? _c("subscription-step-subscription", {
                            attrs: {
                              context: _vm.context,
                              mode: _vm.cart ? "view" : "edit"
                            },
                            on: { load: _vm.load }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.step("cguv") == _vm.activeStep
                    ? _c("subscription-step-cguv", {
                        attrs: { type: "saas", "actual-terms": _vm.terms },
                        on: { load: _vm.load }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step("finalize") == _vm.activeStep
                    ? _c("subscription-step-finalize")
                    : _vm._e()
                ],
                1
              )
            : _vm.userIsSellsy && !_vm.loadingInit
            ? _c(
                "div",
                { staticClass: "m-5" },
                [
                  !_vm.loading
                    ? _c("subscription-sale", {
                        attrs: { permissions: _vm.permissions },
                        on: { load: _vm.load }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "round-64 relative dinlineb valign-middle primary-50-bkg"
      },
      [
        _c("i", {
          staticClass: "fab fa-sellsy absolute-center white",
          staticStyle: { "font-size": "26px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "round-64 relative dinlineb valign-middle primary-50-bkg"
      },
      [
        _c("i", {
          staticClass: "fab fa-sellsy absolute-center white",
          staticStyle: { "font-size": "26px" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }